import React from "react";
import SearchIcon from "@/images/icon-search.svg";
import StarIcon from "@/images/icon-star.svg";
import { AppRoutes } from '@/constants';

import { useStyles } from '../styles/CodeJamSelectProjectAction.styles';

import CodeJamFindProjectCard from "./CodeJamFindProjectCard";
import CodeJamCreateTextJamProject from "./CodeJamCreateTextJamProject";
import CodeJamCreateBlockJamProject from "./CodeJamCreateBlockJamProject";
import TabControl from "./TabControl";
import { IDE_TYPE } from "../model/ide.types";

const Tabs = {
  PLAYGROUND: 1,
  FIND_PROJECT: 2
}

const HEADER_CREATE_NEW = <>Welcome! Create a new project or continue working on an existing one.</>;
const TEXTJAM_HEADER_FIND = <>Select a project to continue or create a new one from scratch.</>;

const CodeJamSelectProjectAction = ({ push, onClose, ideType = IDE_TYPE.TEXT_JAM }) => {
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = React.useState(Tabs.PLAYGROUND);

  const onClickHandle = (route) => {
    onClose();
    push(route);
  }

  const isPlayground = selectedTab === Tabs.PLAYGROUND;
  const isFindProject = selectedTab === Tabs.FIND_PROJECT;

  return <div>
    <div className={classes.headerContainer}>
      {ideType === IDE_TYPE.BLOCK_JAM ?
        HEADER_CREATE_NEW :
        ideType === IDE_TYPE.TEXT_JAM && isPlayground ?
          HEADER_CREATE_NEW : TEXTJAM_HEADER_FIND}
    </div>
    <div className={classes.tabContainer}>
      <div className={classes.tabControl}>
        <TabControl
          isActive={isPlayground}
          logo={StarIcon}
          text="Playground logo"
          onClick={() => {
            setSelectedTab(Tabs.PLAYGROUND)
          }}>Playground</TabControl>
        <TabControl
          isActive={isFindProject}
          logo={SearchIcon}
          text="Find a project logo"
          onClick={() => {
            setSelectedTab(Tabs.FIND_PROJECT)
          }}>Find a project</TabControl>
      </div>
      <div className={classes.tabElementContainer}>
        {isPlayground && ideType === IDE_TYPE.TEXT_JAM && <CodeJamCreateTextJamProject
          onClick={onClickHandle}
        />}

        {isPlayground && ideType === IDE_TYPE.BLOCK_JAM && <CodeJamCreateBlockJamProject
          onClick={onClickHandle}
        />}

        {isFindProject && <CodeJamFindProjectCard
          onButtonClick={() => { onClose(); push(`${AppRoutes.MY_PROJECTS}`); }}
        />}
      </div>
    </div>
  </div>
}

export default CodeJamSelectProjectAction;
